module.exports = __webpack_public_path__ + "static/media/vintage14.72553318.png";